module.exports = __webpack_public_path__ + "img/htmlNo.9667e021.svg";